const initNavigation = (): void => {
    const navbarCollapse = document.getElementById('site-nav-menu');
    const navbarToggler = document.querySelector<HTMLButtonElement>('.site-nav__toggle');

    if (!navbarCollapse || !navbarToggler) {
        return;
    }

    const toggle = (show?: boolean): void => {
        const isOpen = show ?? !navbarCollapse.classList.contains('is-open');
        navbarCollapse.classList.toggle('is-open', isOpen);
        navbarToggler.setAttribute('aria-expanded', String(isOpen));
    };

    navbarToggler.addEventListener('click', () => {
        toggle();
    });

    const onKeyDownHandler = (e: KeyboardEvent): void => {
        if (e.key === 'Escape' && navbarCollapse.classList.contains('is-open')) {
            toggle(false);
            navbarToggler.focus();
        }
    };

    const focusOutHandler = (): void => {
        if (!navbarCollapse.classList.contains('is-open')) {
            return;
        }

        setTimeout(() => {
            const focusedElement = document.activeElement;
            const isFocusInMenu = navbarCollapse.contains(focusedElement);
            const isFocusOnToggler = focusedElement === navbarToggler;

            if (!isFocusInMenu && !isFocusOnToggler) {
                toggle(false);
            }
        }, 10);
    };

    const scrollHandler = ((): (() => void) => {
        let lastScrollTop = 0;
        let isScrolled = false;

        return (): void => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const body = document.body;

            if (!isScrolled && scrollTop > 120) {
                body.setAttribute('data-scrolled', '');
                isScrolled = true;
            } else if (isScrolled && scrollTop < 80) {
                body.removeAttribute('data-scrolled');
                isScrolled = false;
            }

            if (scrollTop > lastScrollTop) {
                body.setAttribute('data-scrolling', 'down');
            } else {
                body.setAttribute('data-scrolling', 'up');
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        };
    })();

    window.addEventListener('scroll', scrollHandler);
    document.addEventListener('keydown', onKeyDownHandler);
    navbarCollapse.addEventListener('focusout', focusOutHandler);
}

export { initNavigation };
